import React from "react";

const DIMS = [
  { key: "technical", label: "Technical knowledge", color: "#C2410C" },
  { key: "problem_solving", label: "Problem solving", color: "#7C3AED" },
  { key: "communication", label: "Communication", color: "#0a66c2" },
  { key: "role_fit", label: "Role fit", color: "#15803D" },
];

/**
 * Dimension breakdown of a screening-interview score.
 * Lets companies weigh technical depth vs communication themselves.
 * props.breakdown: { technical, problem_solving, communication, role_fit }
 */
export default function ScreeningBreakdown({ breakdown, compact = false }) {
  if (!breakdown) return null;
  return (
    <div className={compact ? "space-y-1.5" : "mt-3 space-y-2"}>
      {DIMS.map((d) => {
        const v = Math.round(Number(breakdown[d.key] ?? 0));
        return (
          <div key={d.key}>
            <div className="flex items-center justify-between text-xs mb-0.5">
              <span className="text-stone-600">{d.label}</span>
              <span className="font-mono text-stone-700">{v}</span>
            </div>
            <div className="h-1.5 rounded-full bg-stone-200 overflow-hidden">
              <div className="h-full rounded-full" style={{ width: `${v}%`, background: d.color }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
